const AppRoutes = {
    root: { path: '/' },
    home: {
        path: '/home',
        name: 'Home',
        id: 'Home',
        description: '',
    },
    search: {
        path: '/search',
        name: 'Search',
        id: 'Shearch',
    },
    exploreDetails: {
        path: '/explore/details',
        name: 'Explore Details',
        id: 'ExploreDetails',
    },
    exploreMap: {
        path: '/explore/map',
        name: 'Explore Map',
        id: 'ExploreMap',
    },
};

export default AppRoutes;
